import classNames from 'classnames';
import { IconGift } from 'featherico';
import { useEffect, useRef } from 'react';
import { Divider, OptionLink } from '../../../components/Dropdown';
import { getActiveReleaseNotes } from '../service';
import styles from './style.m.less';

interface Props {
    now: Date;
    lastViewed: Date;
    onHide: () => void;
}

export function JustLaunchedMenuItems({ now, lastViewed, onHide }: Props) {
    const onHideRef = useRef(onHide);
    useEffect(() => {
        onHideRef.current = onHide;
    });
    useEffect(() => () => onHideRef.current(), []);
    return (
        <>
            <Divider />
            <OptionLink href="https://www.small-improvements.com/release-notes" openInNewTab>
                <IconGift /> What's New
            </OptionLink>
            {getActiveReleaseNotes(now.getTime()).map(releaseNote => {
                const isNew = new Date(releaseNote.date).getTime() > lastViewed.getTime();
                return (
                    <OptionLink
                        key={releaseNote.menuItem}
                        href={releaseNote.href}
                        openInNewTab
                        className={classNames(styles.menuItem, {
                            [styles.menuItemNew]: isNew,
                        })}
                    >
                        <span className={styles.dotContainer}>
                            <span
                                className={classNames(styles.dot, {
                                    [styles.dotNew]: isNew,
                                })}
                            />
                        </span>{' '}
                        {releaseNote.menuItem}
                    </OptionLink>
                );
            })}
        </>
    );
}
